export default __webpack_public_path__ + "media/images/ui-bg_diagonals-thick_20_666666_40x40-490ac31fa93f68f9292323e037937bec.png";